/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Xid/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Xid({
  children,
  viewPath = "/App/Account/Topbar/Options/Content/Xid"
  
}) {
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let globalCurrentLocationXidValueData = fromData.useDataFormat({ viewPath,
context: 'global',
path: 'current_location.xid',
format: fromFormat.toUpperCase,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Xid.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-nCm': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--mb-2-nCm': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--ml-3-nCm': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Company code:"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="global.current_location.xid"
 format="/Data/format.js toUpperCase"
 text={globalCurrentLocationXidValueData}
 marginLeft={dtSpaceXxs}
/>
</div>
{children}
</React.Fragment>)
}